import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { makeStyles } from '@mui/styles';

import React from 'react';

const useStyles = makeStyles((theme) => ({
  box: {
    display: 'inline-flex',
    flexWrap: 'wrap',
    margin: `${theme.spacing(0.5)} 0`,
    maxWidth: '25%',
    cursor: 'pointer',
    alignItems: 'baseline',
  },
  pibo: {
    fontFamily: '"Comfortaa", "sans-serif"',
    color: '#d1d3d4',
    '&>span': {
      color: theme.palette.secondary.main,
    },
    marginRight: theme.spacing(0.5),
    fontWeight: 900,
    fontSize: '16px',
    textShadow: '0 0 .5px #d1d3d4',
  },
  text: {
    fontFamily: '"Comfortaa", "sans-serif"',
    fontWeight: 900,
    fontSize: '16px',
    lineHeight: 1.15,
    letterSpacing: '-.75px',
    wordBreak: 'keep-all',
    '@media(max-width: 425px)': {
      display: 'none',
    },
  },
}));

const Logo = ({ onClick }) => {
  const classes = useStyles();
  return (
    <Box className={classes.box} onClick={onClick}>
      <Typography component="h1" className={classes.pibo}>
        <span>pi</span>bo
      </Typography>
      <Typography component="h1" className={classes.text}>
        Manager Console
      </Typography>
    </Box>
  );
};

export default Logo;
